import { Component, OnDestroy, OnInit } from '@angular/core'
import { Store, select } from '@ngrx/store'
import Validator from '@shared/validatorjs/src/validator'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import {
  CreateIndustryRequest,
  SetDefaultData,
  UpdateField,
} from './../industries.actions'
import { getCreateIndustryState } from './../industries.selectors'

@Component({
  selector: 'app-create-industry',
  templateUrl: './create-industry.component.html',
  styleUrls: ['./create-industry.component.css'],
})
export class CreateIndustryComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createIndustry'))
    this.state$ = this.store
      .pipe(select(getCreateIndustryState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    row: null | number = null,
  ): void {
    if (row !== null) {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name
            ? e
            : isNaN(e.target.value)
            ? e.target.value
            : parseFloat(e.target.value),
          `createIndustry.data.subIndustryList.${row}`,
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'createIndustry.data',
        ),
      )

      this.store.dispatch(
        new UpdateField(
          'validationErrors',
          this.state.get('validationErrors').delete(name || e.target.name),
          'createIndustry',
        ),
      )
    }
  }

  public rowDelete(row: number) {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.delete(row).toJS(),
        `createIndustry.data`,
      ),
    )
  }

  public rowAdd() {
    const list = this.state.getIn(['data', 'subIndustryList']) as any
    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.push({ name: '', industry: null }).toJS(),
        `createIndustry.data`,
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateIndustryRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createIndustry',
        ),
      )
    }
  }
}
